import { Component, Input, OnInit } from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { CustomerContactsService } from '../../../../services/customer-contacts.service';
import { RequestParams } from '../../../../../../common/rest-api/models/request-params';
import { AllStopCustomer, IStopCustomer } from './models/stopCustomer.model';

@Component({
  selector: 'app-customer-ar-status-page',
  templateUrl: 'customer-ar-status.page.html',
  styleUrls: [
     './customer-ar-status.page.scss',
     '../../../../styles/g-route.styles.scss'
  ]
})
export class CustomerARStatusPage implements ViewWillEnter, OnInit {
   customer: IStopCustomer;
    currentRoute: string;
    stopName: string;
    requestParams: RequestParams;
    totalBalance:number;
    routeStopName: string = "";
    breadcrumbs=[];
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private customerContactsService: CustomerContactsService
    ) { 
        this.currentRoute = null;
    }

    ngOnInit(): void {
        this.currentRoute = this.router.url;
        this.requestParams = new RequestParams();
        this.requestParams.setPaging(1, 0);
        this.stopName = this.route.snapshot.paramMap.get('id');

        this.routeStopName = localStorage.getItem('routeStopName');
        this.breadcrumbs.push({ label: 'Home', url: '/route' });
        this.breadcrumbs.push({ label: 'Logsheet', url: '/route/logsheet' });
        this.breadcrumbs.push({ label: 'Stop', url: '/route/logsheet/stop/'+ this.stopName });
        window.dispatchEvent(new Event('resize'));
    }

    ionViewWillEnter(): void {
        this.getCustomerArStatus();
    }

     isClassActive( periodName: number): boolean {

        if(this.customer.period4>0 && 4==periodName ){
            return true;
        }
        else if(this.customer.period3>0 && 3==periodName){
            if(this.customer.period4==0 ){
           return true;
            }
        }
        else if(this.customer.period2>0 && 2==periodName){
            if(this.customer.period4==0 && this.customer.period3==0 ){
            return true;
            }
        }
        else if(this.customer.period1>0 && 1==periodName){
            if(this.customer.period4==0 && this.customer.period3==0 && this.customer.period2==0  ){
           return true
            }
        }
        else{
            return false;
        }
          }
    async getCustomerArStatus(): Promise<void> {
        this.customer = await this.customerContactsService.getCustomerArStatusDetail(this.stopName);

       this.totalBalance= this.customer.currBal+this.customer.period1+ 
                            this.customer.period2+this.customer.period3+this.customer.period4;
         
    }
 

}